import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Show_Message } from "../General/Messagedialogbox";
import { API_FETCH, API_POST } from "../General/Utility";

// Single-screen version of the admin "Voucher Number Settings" table
// (see VoucherNo.js) - scoped down to just props.iScrId so it can be
// opened as a quick popup from the gear icon next to Voucher No on the
// Payment screen, instead of sending the user to the full admin list.
// Uses the REAL ConfigurationSetting endpoints/field names confirmed
// from VoucherNo.js (my first draft of this file guessed wrong routes -
// this one mirrors the actual working screen exactly).
function VouchernoSetting(props) {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);

  const [scrRow, setScrRow] = useState(null);
  const [isAutoNo, setisAutoNo] = useState(true);
  const [strNoFormat, setstrNoFormat] = useState("");
  const [iNextNo, setiNextNo] = useState(0);
  const [iMaxDegit, setiMaxDegit] = useState(0);
  const [strInvNo, setstrInvNo] = useState("");
  const [isChanged, setisChanged] = useState(false);

  useEffect(() => {
    Load_VoucherNo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Load_VoucherNo = async () => {
    const res = await API_POST(
      "ConfigurationSetting/Load_VoucherNumberSetting/",
      {
        strSearch: "",
        iBranchId: Number(_AuthParems.Branch),
        strDBName: _AuthParems.DB,
      },
      dispatch
    );
    if (res) {
      // The endpoint returns every screen's row - this popup only cares
      // about the one screen it was opened for.
      const row = (res.EntVouchSett || []).find(
        (Data) => Number(Data.scrId) === Number(props.iScrId)
      );
      if (!row) {
        Show_Message(
          dispatch,
          "Voucher number setting not found for this screen",
          "info"
        );
        return;
      }
      setScrRow(row);
      setisAutoNo(!row.isManualNumber);
      setstrInvNo(row.userNo);
      setstrNoFormat(row.userNoFormat);
      setiNextNo(row.nextNumber);
      setiMaxDegit(row.numSeqMaxDigit);
    }
  };

  const Validate_NextNumber = async () => {
    if (String(iNextNo).length > Number(iMaxDegit)) {
      Show_Message(dispatch, "Next Number Lenth More the MaxDigit", "info");
      return false;
    }
    const res = await API_FETCH(
      `ConfigurationSetting/View_NextNumber/${props.iScrId}/${Number(
        iNextNo
      )}/${Number(_AuthParems.Branch)}/${_AuthParems.DB}`,
      dispatch
    );
    // API_FETCH already shows the message for an "info"/"error" backend
    // status and returns undefined in that case.
    return res !== undefined;
  };

  const UpdateVoucherNo = async () => {
    if (strNoFormat.length > 0 && !strNoFormat.includes("#N")) {
      Show_Message(dispatch, "#N is Mandatory", "info");
      return;
    }
    if (isAutoNo) {
      const ok = await Validate_NextNumber();
      if (!ok) return;
    }
    const updatedRow = {
      ...scrRow,
      numSeqMaxDigit: Number(iMaxDegit),
      nextNumber: Number(iNextNo),
      userNoFormat: strNoFormat,
      isManualNumber: !isAutoNo,
    };
    const res = await API_POST(
      "ConfigurationSetting/Update_VoucherNumSetting/",
      {
        objEntVoucherNo: [updatedRow],
        strDBName: _AuthParems.DB,
        iBranchId: Number(_AuthParems.Branch),
      },
      dispatch
    );
    if (res) {
      Show_Message(dispatch, res.strMessage, "success");
      setisChanged(true);
      Load_VoucherNo();
    }
  };

  const Popup_Close = () => {
    // Reuse Payment.js's own (already-working) Load_Payment reload instead
    // of a bespoke "refresh just the number format" call, so the Voucher
    // No / Trans No boxes pick up the new format immediately.
    if (isChanged && props.onSaved) props.onSaved();
    props.Close();
  };

  return (
    <div className="popup-container">
      <div className="popup-content config-popup">
        <div className="popup-header">
          <h5>Voucher Number Configuration</h5>
          <div className="icon-popup-btn-grp">
            <span className="icon-btn" onClick={Popup_Close}>
              <i className="fa-regular fa-rectangle-xmark"></i>
            </span>
          </div>
        </div>
        <div className="popup-body">
          <div className="row">
            <p className="config-text">
              {!isAutoNo
                ? "Your invoice numbers are set on auto-generate mode to save your time. Are you sure about changing this setting?"
                : "You have selected manual invoice numbering. Do you want us to auto-generate it for you?"}
            </p>
            {isAutoNo && (
              <p className="config-text1">
                <strong>#C-Company Code </strong>
                <strong>#F-Financial Year</strong>
                <strong>#V-Bill Type Like Sales,Purchase</strong>
                <strong>#N-Bill No</strong>
              </p>
            )}
            <div className="row">
              <div className="col-sm-12 col-md-12">
                <div className="inv-check">
                  <input
                    type="checkbox"
                    checked={isAutoNo}
                    onChange={() => setisAutoNo(!isAutoNo)}
                  />
                  <label style={{ fontWeight: isAutoNo ? "bold" : "normal" }}>
                    Continue auto-generating invoice numbers
                  </label>
                </div>
              </div>
              {isAutoNo && (
                <div className="col-sm-6 col-md-3">
                  <label>Max Degit</label>
                  <input
                    type="number"
                    className="form-control"
                    autoComplete="off"
                    spellCheck="off"
                    value={iMaxDegit}
                    onChange={(e) => setiMaxDegit(e.target.value)}
                    placeholder="0"
                    onClick={(e) => e.target.select()}
                  />
                </div>
              )}
              {isAutoNo && (
                <div className="col-sm-6 col-md-3">
                  <label>Next No</label>
                  <input
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    spellCheck="off"
                    value={iNextNo}
                    placeholder="000"
                    onChange={(e) => setiNextNo(e.target.value)}
                    onClick={(e) => e.target.select()}
                  />
                </div>
              )}
              {isAutoNo && (
                <div className="col-sm-6 col-md-3">
                  <label>Inv Formate</label>
                  <input
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    spellCheck="off"
                    value={strNoFormat}
                    onChange={(e) => setstrNoFormat(e.target.value)}
                    placeholder="Inv-"
                    onClick={(e) => e.target.select()}
                  />
                </div>
              )}
              {isAutoNo && (
                <div className="col-sm-6 col-md-3">
                  <label>Inv No</label>
                  <input
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    spellCheck="off"
                    value={strInvNo}
                    readOnly
                  />
                </div>
              )}
              <div className="col-sm-12 col-md-12 ">
                <div className="inv-check">
                  <input
                    type="checkbox"
                    checked={!isAutoNo}
                    onChange={() => setisAutoNo(!isAutoNo)}
                  />
                  <label style={{ fontWeight: !isAutoNo ? "bold" : "normal" }}>
                    Enter invoice numbers manually
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="popup-footer">
          <div className="popup-btn-group">
            <button className="btn-fabgreen" onClick={UpdateVoucherNo}>
              Save&nbsp; <i className="bx bxs-save"></i>
            </button>
            <button className="btn-fabgreen" onClick={Popup_Close}>
              Cancel&nbsp;<i className="bx bx-block"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VouchernoSetting;